import React, { useState, useEffect } from 'react';
import { useRegisterSW } from 'virtual:pwa-register/react';

// Import các component từ Material-UI
import { Snackbar, Alert, Button, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import DownloadIcon from '@mui/icons-material/Download';
import UpdateIcon from '@mui/icons-material/Update';

const PWAPrompt = () => {
    // --- State cho việc cập nhật phiên bản PWA ---
    const {
        offlineReady: [offlineReady, setOfflineReady],
        needRefresh: [needRefresh, setNeedRefresh],
        updateServiceWorker,
    } = useRegisterSW({
        onRegistered(r) {
            console.log('Service Worker đã được đăng ký.', r);
        },
        onRegisterError(error) {
            console.log('Lỗi đăng ký Service Worker:', error);
        },
    });

    // --- State cho việc cài đặt PWA ---
    const [showInstallPrompt, setShowInstallPrompt] = useState(false);
    const [deferredPrompt, setDeferredPrompt] = useState(null);

    useEffect(() => {
        const handler = (e) => {
            e.preventDefault();
            setDeferredPrompt(e);
            if (!needRefresh) { // Chỉ hiển thị nếu không có thông báo cập nhật
                setShowInstallPrompt(true);
            }
        };
        window.addEventListener('beforeinstallprompt', handler);
        return () => window.removeEventListener('beforeinstallprompt', handler);
    }, [needRefresh]);

    useEffect(()=>{
        setTimeout(()=>{
            setShowInstallPrompt(false);
        },30*1000)
    },[])


    // --- Xử lý sự kiện ---

    const handleInstallClick = async () => {
        if (!deferredPrompt) return;
        deferredPrompt.prompt();
        await deferredPrompt.userChoice;
        setDeferredPrompt(null);
        setShowInstallPrompt(false);
    };

    const handleUpdateClick = () => {
        updateServiceWorker(true);
    };

    const handleClose = () => {
        setOfflineReady(false);
        setNeedRefresh(false);
        setShowInstallPrompt(false);
    };

    // --- Render Component ---

    return (
        <Snackbar
            open={showInstallPrompt || needRefresh || offlineReady}
            // Đóng khi người dùng click ra ngoài (không tự động ẩn)
            onClose={(event, reason) => {
                if (reason === 'clickaway') {
                    return;
                }
                handleClose();
            }}
            // Vị trí ở góc dưới bên phải
            anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        >
            {/* Chúng ta sẽ hiển thị Alert phù hợp với từng trường hợp */}
            {needRefresh ? (
                // Trường hợp 1: Có phiên bản mới
                <Alert
                    severity="info"
                    icon={<UpdateIcon fontSize="inherit" />}
                    action={
                        <>
                            <Button color="inherit" size="small" onClick={handleUpdateClick}>
                                Cập nhật
                            </Button>
                            <IconButton size="small" aria-label="close" color="inherit" onClick={handleClose}>
                                <CloseIcon fontSize="small" />
                            </IconButton>
                        </>
                    }
                >
                    Đã có phiên bản mới. Hãy cập nhật để trải nghiệm!
                </Alert>
            ) : showInstallPrompt ? (
                // Trường hợp 2: Có thể cài đặt ứng dụng
                <Alert
                    severity="info"
                    icon={<DownloadIcon fontSize="inherit" />}
                    action={
                        <>
                            <Button color="inherit" size="small" onClick={handleInstallClick}>
                                Cài đặt
                            </Button>
                            <IconButton size="small" aria-label="close" color="inherit" onClick={handleClose}>
                                <CloseIcon fontSize="small" />
                            </IconButton>
                        </>
                    }
                >
                    Cài đặt ứng dụng để có trải nghiệm tốt nhất!
                </Alert>
            ) : offlineReady ? (
                 // Trường hợp 3: Ứng dụng sẵn sàng offline
                 <Alert
                    severity="success"
                    onClose={handleClose}
                >
                    Ứng dụng đã sẵn sàng hoạt động!
                </Alert>
            ) : (
                // Fallback trống để tránh lỗi
                <div></div>
            )
        }
        </Snackbar>
    );
};

export default PWAPrompt;